import { gql } from '@apollo/client';

export const createControllerNote = gql`
  mutation createControllerNote($input: CreateControllerNoteInput) {
    createControllerNote(input: $input) {
      category
      AORId
      AORName
      addToTurnover
      abnormalOperation
      city
      contactId
      contactName
      createdAt
      county
      createdBy
      facilityName
      facilityId
      facilityUID
      falseAlarm
      id
      maop
      noteType
      phoneNumber
      pipeline
      pipelineSection
      state
      township
      updatedAt
      updater
      systemName
      SCADAControl {
        id
        name
      }
      entries {
        controllerNotesId
        createdAt
        createdBy
        id
        note
        time
        updatedAt
        updater
        version
      }
    }
  }
`;
